module.exports = __webpack_public_path__ + "static/media/9.71bd7d05.jpg";